var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"flat":"","tile":""}},[_c('v-card-text',{staticClass:"ma-0 pa-0"},[_c('v-row',{attrs:{"no-gutters":""}},[_c('v-col',{attrs:{"cols":"12"}},[[_c('router-view')]],2)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }